/* The analysis engine, as one import with one defined load order.
 *
 * The modules find each other through the `window.*` registry the single-file
 * build used, so import order IS load order: engine.js registers the
 * functions grounding.js calls, and engine.js republishes its top-level
 * declarations onto globalThis because grounding.js reads STATE_PROFILES
 * through a `typeof` feature test. Importing this file rather than the parts
 * keeps that order in one place.
 *
 * retroAnchor.js registers the prior-acts / ERP vocabulary engine.js reads at
 * analysis time, so it loads first.
 *
 * Outside a browser, call installDomShim() BEFORE importing anything here:
 * escapeHtml is built on document.createElement, and the module registers
 * itself on window.
 */
import './retroAnchor.js';
import './coverageTerms.js';
import './gazetteer.js';   // place names, read by grounding.js
import './locations.js';   // address-role verification (spVerifyLocations)
import './fields.js';      // (label, value, scope) — one reader for every layout
import * as engine from './engine.js';
import './grounding.js';

export * from './engine.js';
export { engine };

/** Bind the handlers the single-file build attached at parse time. Browser
 *  only; call once the form is mounted. Returns how many were bound. */
export function attachEngineHandlers() {
  return engine.spAttachLegacyHandlers();
}
